
import {RouteConfig}  from "@eco/client";
import { RouteProps } from "react-router-dom"
import {RecoilState} from "recoil"

export type EcoInitialState = {
    state : RecoilState<unknown>,
    value: unknown
}

/**
 * 
 * Map of non lazy routes mapping component path+name to corresponding 
 * component instance.
 * {@see }
 * 
 */
export type StaticRouteMappings = {
    [name:string]: React.ReactNode
}

export type EcoRoute = RouteProps & {
    children: EcoRoute[];
    config : RouteConfig ;
}
